import React, { memo, useContext } from 'react';
import { QuickQuoteContext } from '../../contexts/QuickQuote.context';
import { ButtonSize } from '../../interfaces/enums/ButtonSize.enum';
import { ButtonType } from '../../interfaces/enums/ButtonType.enum';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import ButtonLink from '../ButtonLink/ButtonLink';
import classNames from 'classnames';

interface QuickQuoteCTAProps {
  label: string;
  onClick?: (() => void) | ((e: React.MouseEvent<HTMLElement>) => void);
  submit: boolean;
  // isDisabled: boolean;
}

const QuickQuoteCTA: React.FC<QuickQuoteCTAProps> = ({
  label,
  onClick,
  submit,
  // isDisabled,
}) => {
  const { setService, setQuoteStep, quoteStep } = useContext(QuickQuoteContext);

  return (
    <div className="pt-4 grid grid-cols-4">
      <div className="col-span-2 col-start-2">
        <button
          className={classNames(
            'group inline-flex justify-center items-center leading-none transition-all ease-in-out duration-300 cursor-pointer focus:ring-0 focus:outline-none fit-content uppercase rounded-full font-bold border no-underline text-base  border-button/outline-border hover:border-button/outline-bg-hover text-button/outline-label hover:text-button/outline-label-hover bg-transparent hover:bg-button/outline-bg-hover px-6 whitespace-nowrap mx-auto w-full py-4',
            {
              '!bg-[#039855] !border-none text-system/white': submit,
              // 'opacity-50': isDisabled,
            }
          )}
          onClick={onClick}
          type={submit ? 'submit' : 'button'}
        >
          {label}
        </button>
      </div>
    </div>
  );
};

export default memo(withBlokWrapper(QuickQuoteCTA, Theme.ALT));
